import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../messages/messagesActions";
import { ERROR_MESSAGES } from "../../../constants/enums";
import { IAddressHistory } from "./habitationalAddressHistory.types";

export const FETCH_ADDRESS_HISTORY_LIST_PROGRESS =
  "FETCH_ADDRESS_HISTORY_LIST_PROGRESS";
export const FETCH_ADDRESS_HISTORY_LIST_SUCCESS =
  "FETCH_ADDRESS_HISTORY_LIST_SUCCESS";
export const FETCH_ADDRESS_HISTORY_LIST_FAILED =
  "FETCH_ADDRESS_HISTORY_LIST_FAILED";
export const CLEAR_ADDRESS_HISTORY_STATE = "CLEAR_ADDRESS_HISTORY_STATE";

export const clearAddressHistoryState = () =>
  action(CLEAR_ADDRESS_HISTORY_STATE);

export const addAddressHistoryAsync =
  (
    data: IAddressHistory,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      await api.post("/policy/edit-habitational-address-history", {
        ...data,
      });
      onCallback(true);
      dispatch(
        showMessage({
          type: "success",
          message: " saved successfully!",
          displayAs: "snackbar",
        })
      );
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };


export const fetchAddressHistoryListProgress = () =>
  action(FETCH_ADDRESS_HISTORY_LIST_PROGRESS);
export const fetchAddressHistoryListSuccess = (data: IAddressHistory[]) =>
  action(FETCH_ADDRESS_HISTORY_LIST_SUCCESS, {
    data,
  });
export const fetchAddressHistoryListFailed = (errorMessage: string) =>
  action(FETCH_ADDRESS_HISTORY_LIST_FAILED, { errorMessage });

export const fetchAddressHistoryListAsync =
  (
    customerPolicyId: number,
    status?: string
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchAddressHistoryListProgress());

      let finalUrl = `/policy/get-habitational-address-history?customer_policy_id=${customerPolicyId}`;

      if (status !== undefined && status !== "-1") {
        finalUrl += "&status=" + status;
      }

      const res = await api.get(finalUrl);
      const data: IAddressHistory[] = res.data.data;
      dispatch(fetchAddressHistoryListSuccess(data));
    } catch (err: any) {
      dispatch(fetchAddressHistoryListFailed(ERROR_MESSAGES.SERVER_ERROR));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const FETCH_ADDRESS_HISTORY_PROGRESS = "FETCH_ADDRESS_HISTORY_PROGRESS";
export const FETCH_ADDRESS_HISTORY_SUCCESS = "FETCH_ADDRESS_HISTORY_SUCCESS";
export const FETCH_ADDRESS_HISTORY_FAILED = "FETCH_ADDRESS_HISTORY_FAILED";

export const fetchAddressHistoryProgress = () =>
  action(FETCH_ADDRESS_HISTORY_PROGRESS);
export const fetchAddressHistorySuccess = (data: IAddressHistory) =>
  action(FETCH_ADDRESS_HISTORY_SUCCESS, {
    data,
  });
export const fetchAddressHistoryFailed = (errorMessage: string) =>
  action(FETCH_ADDRESS_HISTORY_FAILED, { errorMessage });

export const fetchAddressHistoryAsync =
  (
    customerPolicyId: number,
    incremental_number: number
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchAddressHistoryProgress());
      const res = await api.get(
        `/policy/get-habitational-address-history?customer_policy_id=${customerPolicyId}&column=incremental_number&value=${incremental_number}`
      );
      const data: IAddressHistory[] = res.data.data;
      if (data.length > 0) {
        dispatch(
          fetchAddressHistorySuccess({
            ...data[0],
          })
        );
      } else {
        dispatch(fetchAddressHistoryFailed(ERROR_MESSAGES.POLICY_NOT_FOUND));
      }
    } catch (err: any) {
      dispatch(fetchAddressHistoryFailed(ERROR_MESSAGES.SERVER_ERROR));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };
